<div class="note-form-container">
  <form #NoteForm="ngForm">
    <rms-textarea name="NoteText" [required]="true" label="Note Text" [(ngModel)]="Note.NoteText"></rms-textarea>
    <div class="field-row">
      <rms-date name="FollowUpDate" label="Follow Up Date" [(ngModel)]="Note.FollowUpDate"></rms-date>
      <rms-number name="RelatedOrderID" label="Related Order ID" [(ngModel)]="Note.RelatedOrderID"></rms-number>
      <rms-number name="RelatedSampleRequestID" label="Related Sample ID" [(ngModel)]="Note.RelatedSampleRequestID"></rms-number>
    </div>
    <p class="c-market-note">The C Market value is captured automatically at the time this note is saved.</p>
  </form>
  <div class="button-container">
    <button mat-button class="btn-bg-green" [disabled]="!NoteForm.valid" (click)="save()">Save</button>
    <button mat-button class="btn-bg-red" (click)="cancel()">Cancel</button>
  </div>
</div>
